window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

function jZoom() {
  $main_img_link = $(".product_main_image a");
  $main_img_link.trigger("zoom.destroy");
  $main_img_link.addClass("image-zoom").zoom({
    url: $("img", this).attr("data-zoom"),
  });
}

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productFeaturedImageLink: "[data-product-featured-image-link]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
    quantityWrapper: "[data-quantity-wrapper]",
    backInStock: "[data-quantity-back-in-stock]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$featuredImageLink = $(
      selectors.productFeaturedImageLink,
      this.$container
    );

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
        $(selectors.quantityWrapper, this.$container).removeClass("hide");
        $(selectors.backInStock, this.$container).addClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        $(selectors.quantityWrapper, this.$container).addClass("hide");
        $(selectors.backInStock, this.$container).removeClass("hide");
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
      this.$featuredImageLink.attr("src", sizedImgUrl);

      jZoom();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  // Quick Add Modal Variant Picker Logic
  $(document).on("click", ".quick-add-modal .variant-swatch", function () {
    var $swatch = $(this);
    var $modal = $swatch.closest(".quick-add-modal");
    var productId = $modal.attr("id").replace("quick-add-modal-", "");
    var optionPosition = $swatch.data("option-position");
    var value = $swatch.data("value");
    // Actualiza el select correspondiente
    $modal
      .find('.variant-select[data-option-position="' + optionPosition + '"]')
      .val(value)
      .trigger("change");
    // Actualiza el estado visual
    $swatch.siblings().removeClass("selected");
    $swatch.addClass("selected");
    updateQuickAddVariantId($modal, productId);
  });

  $(document).on("change", ".quick-add-modal .variant-select", function () {
    var $modal = $(this).closest(".quick-add-modal");
    var productId = $modal.attr("id").replace("quick-add-modal-", "");
    updateQuickAddVariantId($modal, productId);
  });

  function updateQuickAddVariantId($modal, productId) {
    var productVariants =
      window.quickAddVariants && window.quickAddVariants[productId];
    if (!productVariants) return;
    var selectedOptions = [];
    $modal.find(".variant-select").each(function () {
      selectedOptions.push($(this).val());
    });
    var found = productVariants.find(function (variant) {
      return variant.options.join() === selectedOptions.join();
    });
    if (found) {
      $modal.find('input[name="id"]').val(found.id);
    }
  }

  // Inicializa los datos de variantes para cada producto en la página
  window.quickAddVariants = window.quickAddVariants || {};
  $(".quick-add-modal").each(function () {
    var $modal = $(this);
    var productId = $modal.attr("id").replace("quick-add-modal-", "");
    var variantsData = $modal.data("variants");
    if (variantsData) {
      window.quickAddVariants[productId] = variantsData;
    } else {
      // fallback: busca en un script inline si existe
      var script = $modal.find("script.quick-add-variants-json");
      if (script.length) {
        window.quickAddVariants[productId] = JSON.parse(script.html());
      }
    }
  });
});
var sections = new slate.Sections();
sections.register("product", theme.Product);

// Common a11y fixes
slate.a11y.pageLinkFocus($(window.location.hash));

$(".in-page-link").on("click", function (evt) {
  slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
});

// Target tables to make them scrollable
var tableSelectors = ".rte table";

slate.rte.wrapTable({
  $tables: $(tableSelectors),
  tableWrapperClass: "rte__table-wrapper",
});

// Target iframes to make them responsive
var iframeSelectors =
  '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

slate.rte.wrapIframe({
  $iframes: $(iframeSelectors),
  iframeWrapperClass: "rte__video-wrapper",
});

// Apply a specific class to the html element for browser support of cookies.
if (slate.cart.cookiesEnabled()) {
  document.documentElement.className =
    document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
}

$("a[data-product-single-thumbnail]").click(function (e) {
  e.preventDefault();
  var new_image = $(this).attr("href");
  var large_image = $("img", this).data("zoom");
  $("img[data-product-featured-image]").prop("src", new_image);
  $("img[data-product-featured-image]").attr("data-zoom", large_image);
  $(".product-main-image > a").attr("href", large_image);
  jZoom();
});

function jZoom() {
  $main_img_link = $(".product-main-image a");
  $main_img_link.trigger("zoom.destroy");
  $main_img_link.addClass("image-zoom").zoom({
    url: $("img", this).attr("data-zoom"),
  });
}

jZoom();

$main_img_link.click(function (e) {
  e.preventDefault();
});

$(".fa-bars, .fa-times").click(function () {
  $(".mobile-nav").slideToggle();
  $(".fa-bars, .fa-times").toggle();
});

$(".mobile_menu--has-submenu > .site-nav__link").click(function (e) {
  e.preventDefault();
  $(this)
    .siblings(".site-nav__submenu")
    .slideToggle(function () {
      if ($(this).is(":visible") === true) {
        $(this)
          .siblings($(".site-nav__link"))
          .children($(".mobile_nav_button"))
          .addClass("arrow_up");
        $(this)
          .siblings($(".site-nav__link"))
          .children($(".mobile_nav_button"))
          .removeClass("arrow_down");
      } else if ($(this).is(":visible") === false) {
        $(this)
          .siblings($(".site-nav__link"))
          .children($(".mobile_nav_button"))
          .removeClass("arrow_up");
        $(this)
          .siblings($(".site-nav__link"))
          .children($(".mobile_nav_button"))
          .addClass("arrow_down");
      }
    });
});

// Commented out to prevent interference with custom variant pickers
/*
  if ($("[data-single-option-selector]").length) {
    $("[data-single-option-selector]").each(function (i) {
      var $thisSelect = $(this);
      var $newClass = "js-option-selector-" + i;
      var $newOptions = '<ul class="new-variant-swatches">';
      var $currentOption = $thisSelect.val();

      $thisSelect.find("option").each(function () {
        var $this = $(this);
        var $optionText = $this.text();
        var $optionVal = $this.val();
        var $soldOut = $this.hasClass("is-soldout");

        $newOptions +=
          '<li class="new-variant-swatch js-new-variant-swatch' +
          ($currentOption == $optionVal ? " is-active" : "") +
          ($soldOut ? " is-soldout" : "") +
          '" data-val="' +
          $optionVal +
          '" data-select="' +
          $newClass +
          '">' +
          $optionText +
          "</li>";
      });

      $thisSelect
        .addClass("is-hidden")
        .addClass($newClass)
        .after($newOptions + "</ul>");
    });

    $(document).on("click", ".js-new-variant-swatch", function () {
      if (!$(this).hasClass("is-soldout")) {
        var $this = $(this);
        var $select = $this.attr("data-select");
        var $val = $this.attr("data-val");
        var $parent = $this.parent("ul");

        $("." + $select)
          .val($val)
          .trigger("change");
        $parent.children("li").removeClass("is-active");
        $(this).addClass("is-active");
      }
    });
  }
  */

// browser window scroll (in pixels) after which the "back to top" link is shown
var offset = 300,
  //duration of the top scrolling animation (in ms)
  scroll_top_duration = 700,
  //grab the "back to top" link
  $back_to_top = $(".back-top");

//hide or show the "back to top" link
$(window).scroll(function () {
  $(this).scrollTop() > offset
    ? $back_to_top.addClass("bt-is-visible")
    : $back_to_top.removeClass("bt-is-visible");
});

//smooth scroll to top
$back_to_top.on("click", function (event) {
  event.preventDefault();
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    scroll_top_duration
  );
});

// Accordion toggle for product accordions

// Accordion toggle for product accordions (independent open/close)

// Vanilla JS accordion logic: first open, rest closed
document.addEventListener("DOMContentLoaded", function () {
  var accordions = document.querySelectorAll(
    ".product-accordions .accordion-item"
  );
  accordions.forEach(function (item, idx) {
    var content = item.querySelector(".accordion-content");
    var toggle = item.querySelector(".accordion-toggle");
    // Open the first accordion by default
    if (idx === 0) {
      content.classList.add("open");
    } else {
      content.classList.remove("open");
    }
    if (toggle) {
      toggle.addEventListener("click", function () {
        var isOpen = content.classList.contains("open");
        if (isOpen) {
          content.classList.remove("open");
        } else {
          content.classList.add("open");
        }
      });
    }
  });
});
